module.exports = __webpack_public_path__ + "img/SLB.8fc7e1b4.svg";